import { generateHash } from "./hashUtil";
import api from "./axiosInstance";

export const handleSentimentSummary = (sessionIds = [], token) => {
  return new Promise((resolve, reject) => {
    // Normalize sessionIds to an array of strings
    if (typeof sessionIds === "string") {
      sessionIds = [sessionIds];
    } else if (!Array.isArray(sessionIds)) {
      console.error("Invalid sessionIds format. Must be string or array.");
      resolve("Invalid sessionIds format");
      return;
    }

    // Remove duplicate sessionIds
    sessionIds = [...new Set(sessionIds)];

    if (sessionIds.length === 0) {
      console.error(
        "No session IDs provided, skipping sentiment summary API call"
      );
      resolve("No session IDs");
      return;
    }

    const stringParams = {
      sessionIds:
        sessionIds.length === 1
          ? sessionIds[0].toString()
          : sessionIds.join(""),
    };

    const hexHash = generateHash(stringParams);

    api
      .post(`/api/session-sentiment-ranking`, sessionIds, {
        headers: {
          // Security Headers
          "X-XSS-Protection": "1; mode=block",
          Authorization: `Bearer ${token}`,
          "X-Content-Type-Options": "nosniff",
          "X-Frame-Options": "DENY",
          "Referrer-Policy": "strict-origin-when-cross-origin",
          "Permissions-Policy": "camera=(), microphone=(), geolocation=()",
          // Standard Headers
          "Content-Type": "application/json",
        },
        params: {
          HPPcode: hexHash,
        },
      })
      .then((res) => {
        if (res?.data) {
          resolve(res.data);
        } else {
          resolve("No data returned");
        }
      })
      .catch((err) => {
        console.error("Error fetching sentiment summary:", err);
        reject(err);
      });
  });
};
